import { useContext, useMemo } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';

/**
 * Whether the student-identifier login UI (Student Number / Registration Number
 * radio + locked username input) is enabled for this tenant. Driven by the
 * `studentIdentifierLogin` branding flag so only the student instance opts in.
 */
export const useStudentLogin = () => {
  const { experienceSettings } = useContext(PageContext);

  const isStudentLoginEnabled = useMemo(
    () => experienceSettings?.branding.studentIdentifierLogin === true,
    [experienceSettings]
  );

  /**
   * Whether password reset may resolve a student number through the anonymous lookup route.
   * Off when the deployment disables that route (`DISABLE_STUDENT_IDENTIFIER_LOOKUP`): reset then
   * falls back to the tenant's email/phone methods and the route is never called.
   */
  const isStudentLookupEnabled =
    isStudentLoginEnabled && experienceSettings?.studentIdentifierLookupDisabled !== true;

  return { isStudentLoginEnabled, isStudentLookupEnabled };
};
